import {trustAccountSortFields} from '@/features/trust-accounts/config';
import {getBalanceAmount} from '@/features/trust-accounts/utils';

import {getGuestInviterName} from '../utils';

import type {TrustAccountFilterFields} from '@/features/trust-accounts/config';
import type {GuestSharedTrustAccountDTO} from '@sollapay/types';
import type {ListSortConfig} from '@sollapay/ui/components';

type Account = GuestSharedTrustAccountDTO;

/** A guest's list has no creation date, so the date sort and filter read `sharedAt`. */
export const GUEST_ACCOUNT_FILTER_FIELDS: TrustAccountFilterFields<Account> = {
  getName: account => account.trustAccountName,
  getDate: account => account.sharedAt
};

export const GUEST_ACCOUNT_SORT_CONFIG: ListSortConfig<Account> = {
  order: ['sharedAt', 'trustName', 'type', 'invitedBy', 'balance'],
  fields: {
    sharedAt: {
      i18nKey: 'guest:accounts.row.sharedOn',
      defaultDesc: true,
      getValue: account => new Date(account.sharedAt).getTime()
    },
    invitedBy: {
      i18nKey: 'guest:accounts.row.invitedBy',
      defaultDesc: false,
      getValue: getGuestInviterName
    },
    ...trustAccountSortFields<Account>({
      getName: account => account.trustAccountName,
      getBalance: account => getBalanceAmount(account.trustStatus, account.balance?.balance)
    })
  }
};
